import { Language, LANGUAGE_LABELS, LANGUAGE_FLAGS } from '../types'

interface LanguageSelectorProps {
  value:    Language
  onChange: (value: Language) => void
}

const LANGUAGES: Language[] = ['en', 'sl', 'it']

export default function LanguageSelector({ value, onChange }: LanguageSelectorProps) {
  return (
    <div>
      <label className="config-label">Language</label>
      <div className="flex gap-2" role="radiogroup" aria-label="Language">
        {LANGUAGES.map((lang) => (
          <button
            key={lang}
            role="radio"
            aria-checked={value === lang}
            onClick={() => onChange(lang)}
            className={value === lang ? 'sel-btn-active gap-1' : 'sel-btn gap-1'}
          >
            <span className="text-xl" aria-hidden>{LANGUAGE_FLAGS[lang]}</span>
            <span>{LANGUAGE_LABELS[lang]}</span>
          </button>
        ))}
      </div>
    </div>
  )
}
